import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { PhoneNumberInput } from "react-spark";
import {
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class URCPhoneNumberInput extends Component {
  static cleanValue(value) {
    return value.replace(/\D/g, "");
  }

  static defaultProps = {
    ...withValidationOutputDefaultProps,
    ...sharedFormInputDefaultProps,
    value: ""
  };

  static propTypes = {
    ...withValidationOutputPropTypes,
    ...sharedFormInputPropTypes,
    value: PropTypes.string,
    pattern: PropTypes.string
  };

  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    if (this.props.forceUpdate) {
      this.props.context.updateFormElement({
        value: this.props.value,
        name: this.props.name,
        valid: this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  handlePaste(event) {
    if(this.props.context && this.props.context.addPField) {
      this.props.context.addPField(event.target.name);
    }
  }

  render() {
    const {
      id,
      name,
      value,
      context,
      handleChange,
      handleBlur,
      label,
      disabled,
      errorMessage,
      className,
      helper,
      pattern
    } = this.props;

    return (
      <PhoneNumberInput
        className={className}
        disabled={disabled}
        error={errorMessage}
        id={id}
        label={label}
        name={name}
        onChange={event => handleChange(event, context)}
        onBlur={event => handleBlur(event, context.handleChange)}
        onPaste={event => this.handlePaste(event)}
        helper={helper}
        value={value}
        pattern={pattern}
      />
    );
  }
}

export default withValidation(URCPhoneNumberInput);
